import { Tooltip } from '../Tooltip'

const Button = ({
    children,
    className = '',
    type,
    disabled = false,
    ...props
}) => {
    return (
        <button
            disabled={disabled}
            {...props}
            type={type}
            className={`bg-olm text-white font-semibold relative flex items-center border border-olm rounded-lg p-2 cursor-pointer hover:bg-olh hover:border-olh focus:outline-none focus:ring-1 focus:ring-olh focus:border-olh sm:text-sm ${className}
            ${disabled ? 'bg-gray-300' : 'bg-olm hover:bg-olh '}
        `}>
            {children}
        </button>
    )
}

export function SmallButton({
    children,
    className = '',
    type,
    disabled = false,
    tooltipText = '',
    ...props
}) {
    type = type || 'button'

    if (tooltipText != '') {
        return (
            <Tooltip text={tooltipText}>
                <Button
                    {...{ children, className, type, disabled, ...props }}
                />
            </Tooltip>
        )
    }

    return <Button {...{ children, className, type, disabled, ...props }} />
}
